import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../store/store"

export interface AlertData {
  title?: string
  message: string
  type?: 'info' | 'warning' | 'error' | 'success'
  showCloseButton?: boolean
  autoClose?: boolean
  autoCloseDelay?: number
  duration?: number
}

export interface AlertWindowState {
  isOpen: boolean
  alertData: AlertData | null
}

const initialState: AlertWindowState = {
  isOpen: false,
  alertData: null
}

export const alertWindow = createSlice({
  name: 'alertWindow',
  initialState,
  reducers: {
    showAlert: (state, action: PayloadAction<AlertData>) => {
      state.isOpen = true
      state.alertData = action.payload
    },
    closeAlert: (state) => {
      state.isOpen = false
      state.alertData = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase("CLEANUP", (state) => {
      state.isOpen = false
      state.alertData = null
    });
  }
})

export const { showAlert, closeAlert } = alertWindow.actions

export const selectIsAlertOpen = (state: RootState) => {
  return state.alertWindow.isOpen
}

export const selectAlertData = (state: RootState) => {
  return state.alertWindow.alertData
}

export default alertWindow.reducer
